
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <template v-if="!hideComplete && noDocToBeCompleted">
      <div v-if="!hideComplete && noDocToBeCompleted" class="giga-card">
        <div>
          <h3 class="giga-card_title">{{ $t("documents_complete") }}</h3>
        </div>
        <div class="giga-card_content">
          <table class="giga-table docs-table none-hover">
            <thead>
              <tr>
                <th class="giga-checkAll_table">
                  <div class="giga-cutsom_checkbox" :class="classObjectToBeCompleted">
                    <input type="checkbox" name="checkboxName" v-model="allRowsSelectedToBeCompleted" @change="selectAllRowsToBeCompleted" id="" />
                    <label for="checkboxName"></label>
                  </div>
                </th>
                <th class="giga-document_name">Nom du document</th>
                <th class="giga-document_type">Type</th>
                <th class="giga-document_date">Date de transmission</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="document in documents">
                <tr
                  v-if="!document.transmitted"
                  :key="document.id"
                >
                  <td>
                    <div class="giga-cutsom_checkbox">
                      <input type="checkbox" name="checkboxName" v-model="selectedRowToBeCompleted" :value="document.id" @click="$emit('selectDocument', document.id)" />
                      <label for="checkboxName"></label>
                    </div>
                  </td>
                  <td class="giga-document_name">
                    <div class="giga-document_name_label">
                      <i class="extention-icon">
                        <img v-if="getFileExtention(document.name) == 'xlsx'" src="~@/assets/images/extensions/xls.svg">
                        <img v-else-if="getFileExtention(document.name) == 'txt'" src="~@/assets/images/extensions/txt.svg">
                        <img v-else-if="getFileExtention(document.name) == 'pdf'" src="~@/assets/images/extensions/pdf.svg">
                        <img v-else-if="getFileExtention(document.name) == 'docx'" src="~@/assets/images/extensions/doc.svg">
                        <img v-else-if="getFileExtention(document.name) == 'doc'" src="~@/assets/images/extensions/doc.svg">
                        <img v-else src="~@/assets/images/extensions/text.svg">
                      </i>
                      {{getDocExtention(document.name)}}
                    </div>
                  </td>
                  <td class="giga-document_type">
                    <multiselect
                      v-select-overflow
                      open-direction="bottom"
                      :searchable="false"
                      :closeOnSelect="false"
                      v-model="document.type"
                      :options="getDocumentsTypes"
                      :placeholder="$t('type_document')"
                      :multiple="true"
                      trackBy="code"
                      label="name"
                      :showLabels="false"
                      class="tags-outline"
                      :isRequired="true"
                      :errorMsg="$t('required_field')"
                    >
                      <template slot="caret">
                        <div
                          class="
                            multiselect__select
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b-icon icon="chevron-down"></b-icon>
                        </div>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div
                          class="option__desc d-flex justify-content-between"
                        >
                          <span class="option__title">{{
                            props.option.name
                          }}</span>
                          <span
                            class="option__info-icon right"
                            :desc="props.option.info"
                          >
                            <b-icon
                              class="text-muted"
                              icon="info-circle"
                            ></b-icon>
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </td>
                  <td class="giga-document_date">
                    {{ moment(document.creationDate, "x").format("DD/MM/YYYY") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <!-- END DOCUEMENT COMPLETE -->

    <template v-if="!hideTransmitted">
      <div class="giga-card">
        <div>
          <h3 class="giga-card_title">{{ $t("documents_transmitted") }}</h3>
        </div>
        <div class="giga-card_content">
          <table class="giga-table docs-table none-hover">
            <thead>
              <tr>
                <th class="giga-checkAll_table">
                  <div class="giga-cutsom_checkbox" :class="classObjectToBeCompleted">
                    <input type="checkbox" name="checkboxName" v-model="allRowsSelectedToBeCompleted" @change="selectAllRowsToBeCompleted" id="" />
                    <label for="checkboxName"></label>
                  </div>
                </th>
                <th class="giga-document_name">Nom du document</th>
                <th class="giga-document_type">Type</th>
                <th class="giga-document_date">Date de transmission</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="document in documents">
                <tr
                  v-if="document.transmitted"
                  :key="document.id"
                >
                  <td>
                    <div class="giga-cutsom_checkbox">
                      <input type="checkbox" name="checkboxName" v-model="selectedRowToBeCompleted" :value="document.id" @click="$emit('selectDocument', document.id)" />
                      <label for="checkboxName"></label>
                    </div>
                  </td>
                  <td class="giga-document_name">
                    <div class="giga-document_name_label">
                      <i class="extention-icon">
                        <img v-if="getFileExtention(document.name) == 'xlsx'" src="~@/assets/images/extensions/xls.svg">
                        <img v-else-if="getFileExtention(document.name) == 'txt'" src="~@/assets/images/extensions/txt.svg">
                        <img v-else-if="getFileExtention(document.name) == 'pdf'" src="~@/assets/images/extensions/pdf.svg">
                        <img v-else-if="getFileExtention(document.name) == 'docx'" src="~@/assets/images/extensions/doc.svg">
                        <img v-else-if="getFileExtention(document.name) == 'doc'" src="~@/assets/images/extensions/doc.svg">
                        <img v-else src="~@/assets/images/extensions/text.svg">
                      </i>
                      {{getDocExtention(document.name)}}
                    </div>
                  </td>
                  <td class="giga-document_type">
                    <multiselect
                      v-select-overflow
                      open-direction="bottom"
                      :searchable="false"
                      :closeOnSelect="false"
                      v-model="document.type"
                      :options="getDocumentsTypes"
                      :placeholder="$t('type_document')"
                      :multiple="true"
                      trackBy="code"
                      label="name"
                      :showLabels="false"
                      class="tags-outline"
                      :isRequired="true"
                      :errorMsg="$t('required_field')"
                    >
                      <template slot="caret">
                        <div
                          class="
                            multiselect__select
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <b-icon icon="chevron-down"></b-icon>
                        </div>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div
                          class="option__desc d-flex justify-content-between"
                        >
                          <span class="option__title">{{
                            props.option.name
                          }}</span>
                          <span
                            class="option__info-icon right"
                            :desc="props.option.info"
                          >
                            <b-icon
                              class="text-muted"
                              icon="info-circle"
                            ></b-icon>
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </td>
                  <td class="giga-document_date">
                    {{ moment(document.creationDate, "x").format("DD/MM/YYYY") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <!-- END DOCUEMENT COMPLETE -->

    <!-- <template v-if="!hideComplete && noDocToBeCompleted">
      <small class="d-block mb-3">{{ $t("documents_complete") }}</small>
      <b-row>
        <template v-for="document in documents">
          <b-col
            cols="12"
            md="6"
            xl="4"
            :key="document.id"
            v-if="!document.transmitted"
          >
            <div
              @click="$emit('selectDocument', document.id)"
              v-b-tooltip.hover
              :title="document.name"
              :class="{ active: selectDocuments.includes(document.id) }"
              class="document mb-3 d-flex align-items-center cursor-pointer border border-raduis-sm border-color-muted"
            >
              <span class="icon text-center text-primary mr-2">
                <b-icon icon="file-earmark"></b-icon>
              </span>
              <span class="title text-truncate"> {{ document.name }} </span>
            </div>
          </b-col>
        </template>
      </b-row>
    </template> -->
    <!-- <template v-if="!hideTransmitted">
      <div class="giga-card"> 
        <h3 class="giga-card_title">{{ $t("documents_transmitted") }}</h3>
        <div class="giga-card_content">
          <template v-for="document in documents">
            <b-col
              cols="12"
              md="6"
              xl="4"
              :key="document.id"
              v-if="document.transmitted"
            >
              <div
                @click="$emit('selectDocument', document.id)"
                v-b-tooltip.hover
                :title="document.name"
                :class="{ active: selectDocuments.includes(document.id) }"
                class="document mb-3 d-flex align-items-center cursor-pointer border border-raduis-sm border-color-muted"
              >
                <span class="icon text-center text-primary mr-2">
                  <b-icon icon="file-earmark"></b-icon>
                </span>
                <span class="title text-truncate"> {{ document.name }} </span>
              </div>
            </b-col>
          </template>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
  import { some } from 'lodash';
  import {mapGetters, mapActions} from 'vuex';
  export default {
  name: 'DocumentsList',
  props: ['documents', 'selectDocuments', 'hideComplete', 'hideTransmitted'],
  mounted(){
    this.getDocumentsTypesAction();
  },
  computed: {
    ...mapGetters("document", ["getDocuments", "getDocumentsTypes"]),
    noDocToBeCompleted() {
      return some(this.documents, { transmitted: false });
    }
  },
  methods:{
    ...mapActions("document", [
      "getDocumentsAction",
      "getDocumentsTypesAction",
    ]),
    selectAllRowsToBeCompleted(){
      if(this.allRowsSelectedToBeCompleted){
        const selectedRowToBeCompleted = this.documents.map((doc) => doc.id);
        this.selectedRowToBeCompleted = selectedRowToBeCompleted;
      } else {
        this.selectedRowToBeCompleted = []
      }
    },
    getFileExtention(filename){
      return filename.split('.').pop();
    },
    getDocExtention(docname) {
      let split = docname.split('.');
      let filename = split[0];
      let extension = split[1];
      if(filename.length > 18) {
        docname = filename.substring(0, 18)+'...'+extension;
      }
      return docname;
    },
  }
};
</script>
